<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 46 32"
  >
    <g>
      <path
        fill="#4365e2"
        d="M44.561 5.008c-0.537-1.975-2.054-3.501-3.984-4.040l-0.040-0.010c-4.848-0.617-10.458-0.969-16.15-0.969-0.574 0-1.147 0.004-1.719 0.011l0.087-0.001c-0.491-0.006-1.072-0.010-1.653-0.010-5.684 0-11.287 0.351-16.787 1.032l0.658-0.066c-1.97 0.549-3.487 2.075-4.015 4.009l-0.009 0.040c-0.605 3.316-0.952 7.132-0.952 11.029s0.346 7.713 1.009 11.419l-0.058-0.39c0.541 1.957 2.060 3.463 3.985 3.976l0.039 0.009c4.842 0.615 10.444 0.966 16.129 0.966 0.581 0 1.161-0.004 1.741-0.011l-0.088 0.001c0.491 0.006 1.072 0.010 1.653 0.010 5.684 0 11.287-0.351 16.787-1.032l-0.658 0.066c1.964-0.522 3.483-2.028 4.015-3.945l0.009-0.040c0.605-3.316 0.952-7.132 0.952-11.029s-0.346-7.713-1.009-11.419l0.058 0.39zM18.101 22.801v-13.537l11.894 6.767z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
